import { IConditionBody as IAdvancedSearchSetting } from 'pages/ApprovalDocumentGroup/approvalDocumentList/advancedSearch/type';
import reducer from './reducer';
import * as ApprovalDocumentAdvancedSearchActions from './actions';

export type ApprovalDocumentAdvancedSearchType = {
  advancedSearchSettings: IAdvancedSearchSetting[],
}

export {
  ApprovalDocumentAdvancedSearchActions,
};

export default reducer;
